import { GetServerSideProps, InferGetServerSidePropsType, NextPage } from 'next';

import { ContactUsSection } from '@/components/ui/features/white-glove-service/ContactUsSection/ContactUsSection';
import { DetailsSection } from '@/components/ui/features/white-glove-service/DetailsSection/DetailsSection';
import { WhiteGloveHeading } from '@/components/ui/features/white-glove-service/Heading/Heading';
import { PurpleGradientSection } from '@/components/ui/features/white-glove-service/PurpleGradientSection/PurpleGradientSection';
import { VideoSection } from '@/components/ui/features/white-glove-service/VideoSection/VideoSection';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import { queryTestimonials } from '@/queries/testimonals';
import { generateStore } from '@/utils/generateStore';
import { Hydrate } from '@/utils/swr/Hydrate';

const WhiteGloveServicePage: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = ({ fallback }) => {
  return (
    <Hydrate fallback={fallback}>
      <Layout accessFrom={AccessFrom.Core} navigationVariant="ghost">
        <WhiteGloveHeading />
        <PurpleGradientSection />
        <DetailsSection />
        <VideoSection />
        <ContactUsSection />
      </Layout>
    </Hydrate>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const store = generateStore({ context });

  await store.fetchResources(queryTestimonials());

  return {
    props: {
      fallback: store.fallback,
    },
  };
};
export default WhiteGloveServicePage;
